import { render } from "./AllDepartments.vue?vue&type=template&id=20f4da8a"
import script from "./AllDepartments.vue?vue&type=script&lang=js"
export * from "./AllDepartments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__